import {
    Component, Mixins,
} from 'vue-property-decorator';
import * as loadingTypes from 'epic-spinners';
import config from '@groot-components/shared/config';
import Props from './props';

/**
 * @name Loading
 * @source https://epic-spinners.epicmax.co/
 */
@Component({
    components: {
        ...loadingTypes,
    },
})
class YLoading extends Mixins(Props) {
    /**
     * Return the class of the loading from config.
     * 
     * @returns {string}
     */
    get loadingClass(): string {
        return config.prefix.loading;
    }

    /**
     * Return position style
     * 
     * @returns {string}
     */
    get style(): object {
        const style : any = {
            height           : this.height,
            width            : '100%',
            position         : this.position,
            display          : 'flex',
            'flex-direction' : 'column',
            'justify-content': 'center',
            'align-items'    : 'center',
            'z-index'        : 99999,
        };
        
        if (this.position === 'fixed') {
            style.inset = 0;
        }

        if (this.background) {
            style.backgroundColor = `${this.background} !important`;
        }

        // TODO: Add option to change loading color by prop
        // if (this.color) {
        //     style.borderTopColor = `${this.color} !important`;
        //     style.borderRightColor = `${this.color} !important`;
        // }

        return style;
    }
}

export default YLoading;
